import { Theme } from '@mui/material';


const Avatar = (theme: Theme) => {
  return {
  };
};

export default Avatar;
